export const CONVERSATION_KIND_BROADCAST = "broadcast";
export const CONVERSATION_KIND_PUBLIC = "public";
export const CONVERSATION_KIND_ALL = "all";
export const MESSAGES_CHUNK_LENGTH = 20;
export const ALL_MESSAGES_CHANNEL_ID = "ALL";

